/**
 * @generated SignedSource<<bb0a7e9483a5b3c471cd230d0ece4546>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateSchoolInput = {
  addressFirstLine?: string | null | undefined;
  addressSecondLine?: string | null | undefined;
  city?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  name: string;
  postcode?: string | null | undefined;
};
export type CreateSchoolMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateSchoolInput;
};
export type CreateSchoolMutation$data = {
  readonly createSchool: {
    readonly errors: any | null | undefined;
    readonly school: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"SchoolListFragment_SchoolNode">;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type CreateSchoolMutation = {
  response: CreateSchoolMutation$data;
  variables: CreateSchoolMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasInvalidPhoneNumber",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "DjangoUserNode",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSchoolMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreateSchoolPayload",
        "kind": "LinkedField",
        "name": "createSchool",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SchoolNode",
            "kind": "LinkedField",
            "name": "school",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SchoolListFragment_SchoolNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateSchoolMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreateSchoolPayload",
        "kind": "LinkedField",
        "name": "createSchool",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SchoolNode",
            "kind": "LinkedField",
            "name": "school",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "archived",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfActiveTeachers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfFilledLessonSlots",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfFreeLessonSlots",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "headTeacher",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "mainOfficeContact",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "addressFirstLine",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "addressSecondLine",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "postcode",
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "school",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "SchoolNodeEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b86b3d5e9cbd4a4e3019ed0c27b90fda",
    "id": null,
    "metadata": {},
    "name": "CreateSchoolMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSchoolMutation(\n  $input: CreateSchoolInput!\n) {\n  createSchool(input: $input) {\n    success\n    errors\n    school {\n      id\n      ...SchoolListFragment_SchoolNode\n    }\n  }\n}\n\nfragment SchoolListFragment_SchoolNode on SchoolNode {\n  id\n  name\n  archived\n  numberOfActiveTeachers\n  numberOfFilledLessonSlots\n  numberOfFreeLessonSlots\n  headTeacher {\n    id\n    phoneNumber\n    hasInvalidPhoneNumber\n    user {\n      id\n      firstName\n      lastName\n      email\n    }\n  }\n  mainOfficeContact {\n    id\n    phoneNumber\n    hasInvalidPhoneNumber\n    addressFirstLine\n    addressSecondLine\n    city\n    postcode\n    user {\n      id\n      firstName\n      lastName\n      email\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "87fe74db1f797ebfae2acba3c33ef331";

export default node;
